var _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPiping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f63f401c-0502-45d5-b548-5942aee39fb1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.26,11.58c-1.08,0-3.08.82-4.53,4.47C17,20.63,9.56,29.81,9.56,36.46c0,7.45,5.52,12.75,13.42,12.89h.28C31.34,49.35,37,44,37,36.45c0-4.36-3.51-11.23-5.6-14.93-5.62-10-7.36-10-8.11-10Z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.62,18.68c-2.3,5.81-8.16,13.46-8.16,17.83,0,6.12,4.67,9.94,10.57,10l8.24-11Z",
    fill: "#c9c9c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.26,15.38c-.24,0-1.29,1.3-2.64,3.3L29,35.87,23,46.55h.23c6,0,10.81-3.76,10.81-10S24.49,15.38,23.26,15.38Z",
    fill: "#999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.46,45.35C22.34,45.3,16.41,42,16.41,42l-2.05-5.52,1.82-6.55,1,6,1.43,4.9Z",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "22.89 17.63 19.51 24.01 22.89 21.39 22.89 17.63",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.32,31.68l-1.18-3.09a32.53,32.53,0,0,0,2.37-3.34Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36,7c-.35,0-1,.35-1.49,1.92-.57,2-3,5.92-3,8.78,0,3.2,1.81,5.48,4.41,5.54H36c2.65,0,4.5-2.28,4.5-5.54,0-1.88-1.15-4.83-1.84-6.43C36.81,7,36.24,7,36,7Z",
    fill: "#333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28,0c-.25,0-.7.33-1,1.62-.3,1.63-1.83,4.93-1.69,7.25.16,2.6,1.56,4.37,3.39,4.3h.07c1.87-.11,3.06-2,2.9-4.69A18.37,18.37,0,0,0,30.1,3.35C28.59,0,28.18,0,28,0Z",
    fill: "#333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36,9.52c-.26,0-.74.26-1.09,1.4-.41,1.44-2.19,4.32-2.19,6.41,0,2.34,1.32,4,3.21,4H36c1.94,0,3.29-1.67,3.29-4a15,15,0,0,0-1.35-4.69C36.59,9.52,36.17,9.52,36,9.52Z",
    fill: "#999"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.15,2.33c-.17,0-.47.23-.64,1.14-.21,1.14-1.24,3.46-1.14,5.09.11,1.82,1.06,3.07,2.3,3h0c1.27-.08,2.08-1.43,2-3.29a12.94,12.94,0,0,0-1.1-3.6c-1-2.38-1.31-2.36-1.43-2.36Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiping);
export default __webpack_public_path__ + "static/media/Piping.40422d23321dce8d6aeb0896d06b3c13.svg";
export { ForwardRef as ReactComponent };